import { Icon } from '@y42/core/icon';
import { Y42FeatureType } from '@y42/json-schema';
import {
  alertIcon,
  alertStrokeIcon,
  exportStrokeIcon,
  integrationStrokeIcon,
  modelIcon,
  modelStrokeIcon,
  visualizationIcon,
  visualizationStrokeIcon,
} from '../icons';
import { Y42FeatureTypeToLogo, Y42FeatureTypeToLogoStroke } from '../models/feature-type-to-logo.model';
import { Y42GitFolder, Y42GitFolders } from './wasm-git-folders.model';

interface FeatureDef {
  name: Y42FeatureType;
  logo: Icon;
  logoStroke?: string | null;
}

/**
 * @deprecated
 *
 * Please use `FeatureAggregationService.getLogo...` instead.
 */
export const GitFolderToUI: Record<Y42GitFolder, FeatureDef> = {
  [Y42GitFolders.Integration]: {
    name: Y42FeatureType.Integration,
    logo: Y42FeatureTypeToLogo[Y42FeatureType.Integration],
    logoStroke: integrationStrokeIcon,
  },
  [Y42GitFolders.Model]: {
    name: Y42FeatureType.UiModel,
    logo: modelIcon,
    logoStroke: modelStrokeIcon,
  },
  [Y42GitFolders.UiModel]: {
    name: Y42FeatureType.UiModel,
    logo: Y42FeatureTypeToLogo[Y42FeatureType.UiModel],
    logoStroke: Y42FeatureTypeToLogoStroke[Y42FeatureType.UiModel],
  },
  [Y42GitFolders.SqlModel]: {
    name: Y42FeatureType.SqlModel,
    logo: Y42FeatureTypeToLogo[Y42FeatureType.SqlModel],
    logoStroke: Y42FeatureTypeToLogoStroke[Y42FeatureType.SqlModel],
  },
  [Y42GitFolders.Orchestration]: {
    name: Y42FeatureType.Orchestration,
    logo: Y42FeatureTypeToLogo[Y42FeatureType.Orchestration],
  },
  [Y42GitFolders.Visualization]: {
    name: Y42FeatureType.VisualizationDashboard,
    logo: visualizationIcon,
    logoStroke: visualizationStrokeIcon,
  },
  [Y42GitFolders.VisualizationDashboard]: {
    name: Y42FeatureType.VisualizationDashboard,
    logo: Y42FeatureTypeToLogo[Y42FeatureType.VisualizationDashboard],
    logoStroke: Y42FeatureTypeToLogoStroke[Y42FeatureType.VisualizationDashboard],
  },
  [Y42GitFolders.VisualizationWidget]: {
    name: Y42FeatureType.VisualizationWidget,
    logo: Y42FeatureTypeToLogo[Y42FeatureType.VisualizationWidget],
    logoStroke: Y42FeatureTypeToLogoStroke[Y42FeatureType.VisualizationWidget],
  },
  [Y42GitFolders.VisualizationTheme]: {
    name: Y42FeatureType.VisualizationTheme,
    logo: Y42FeatureTypeToLogo[Y42FeatureType.VisualizationTheme],
  },
  [Y42GitFolders.VisualizationFilter]: {
    name: Y42FeatureType.VisualizationFilter,
    logo: Y42FeatureTypeToLogo[Y42FeatureType.VisualizationFilter],
  },
  [Y42GitFolders.Export]: {
    name: Y42FeatureType.Export,
    logo: Y42FeatureTypeToLogo[Y42FeatureType.Export],
    logoStroke: exportStrokeIcon,
  },
  [Y42GitFolders.Lineage]: {
    name: Y42FeatureType.Lineage,
    logo: Y42FeatureTypeToLogo[Y42FeatureType.Lineage],
  },
  [Y42GitFolders.Alert]: {
    name: Y42FeatureType.StatusAlert,
    logo: alertIcon,
    logoStroke: alertStrokeIcon,
  },
  [Y42GitFolders.AlertStatusAlert]: {
    name: Y42FeatureType.StatusAlert,
    logo: Y42FeatureTypeToLogo[Y42FeatureType.StatusAlert],
    logoStroke: Y42FeatureTypeToLogoStroke[Y42FeatureType.StatusAlert],
  },
  // TODO
  [Y42GitFolders.Catalog]: {
    name: Y42FeatureType.Catalog,
    logo: Y42FeatureTypeToLogo[Y42FeatureType.Catalog],
    logoStroke: Y42FeatureTypeToLogoStroke[Y42FeatureType.Catalog],
  },
};

export const getFeatureDefinitionFor = (featureType: Y42FeatureType): FeatureDef | undefined => {
  const GitFolderToUiTranslatorWithoutModel = { ...GitFolderToUI, [Y42GitFolders.Model]: undefined }; // TODO: ...
  return Object.values(GitFolderToUiTranslatorWithoutModel).find((featureDef) => featureDef?.name === featureType);
};
